/* eslint-disable @typescript-eslint/no-unused-vars */
import { featureTrackerAPI } from "redux/apis";
import { FeatureType } from "interfaces/feature-tracker";
import { useWebStoreContext } from "contexts";
import { SignUpIncentiveResponse } from "interfaces/sign-up-incentive";

import Banner from "./Banner";

const SignUpIncentiveBanner = () => {
	const { authToken } = useWebStoreContext();

	const { data }: { data?: SignUpIncentiveResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.SIGN_UP_INCENTIVE,
			token: authToken?.value
		});

	if (
		!authToken ||
		!data?.tracker?.incentiveRewardId ||
		data?.tracker?.scopelyUserId
	) {
		return null;
	}

	return <Banner data={data} />;
};

export default SignUpIncentiveBanner;
